import { Server } from '#enums';
import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-pssr-status-badge',
  imports: [NgClass, TranslatePipe],
  templateUrl: './pssr-status-badge.html',
  styleUrl: './pssr-status-badge.scss',
})
export class PssrStatusBadge {
  status = input<Server.PSSRStatus>(Server.PSSRStatus.Draft);
  useIcon = input<boolean>(false);
  isDeleted = input<boolean>(false);

  PSSRStatus = Server.PSSRStatus;

  cssClass = computed(() => (this.isDeleted() ? 'pssr-status--deleted' : 'pssr-status--' + this.status()));

  translationKey = computed(() => 'pssrStatuses.' + (this.isDeleted() ? 'Deleted' : Server.PSSRStatus[this.status()]));
}
